import {
    HiddenCols,
    TableHeader,
} from "../components/ReusableComponents/Table";
import {
    KnownExcludedSelectedColumnIds,
    SelectedColumnId,
    allowedSelectedColumns,
} from "../models/app/admin/driver";

type ColumnWithHiddenState = Pick<TableHeader, "hide"> &
    Partial<Pick<HiddenCols, "hidden">> & { id: string };

export const filterVisibleColumnIds = (
    columns: ColumnWithHiddenState[]
): SelectedColumnId[] => {
    const visibleColumnIds = columns.reduce((acc: string[], curr) => {
        if (curr.hidden || curr.hide) {
            return acc;
        } else {
            return [...acc, curr.id];
        }
    }, []);

    return visibleColumnIds.filter((id): id is SelectedColumnId => {
        const knownExcludedColumns: KnownExcludedSelectedColumnIds[] = [
            "name",
            "driverId",
        ];
        const isValidSelectedColumn = allowedSelectedColumns.includes(
            id as SelectedColumnId
        );

        if (
            !isValidSelectedColumn &&
            !knownExcludedColumns.includes(id as KnownExcludedSelectedColumnIds)
        ) {
            console.error(`Column ${id} is not a valid SelectedColumnId`);
        }

        return isValidSelectedColumn;
    });
};
